import { Flex } from 'antd'
// import { Image } from 'react-bootstrap'
import Styles from './style.module.scss'

export default function Index({ banner, title }) {
  return (
    <Flex
      vertical
      align='center'
      justify='center'
      className={Styles.wrapper}
      style={{ backgroundImage: `url(${banner})` }}
    >
      <h1 className={Styles.title}>{title}</h1>
    </Flex>
  )
}
